import { UAParser } from 'ua-parser-js';

/**
 * Uses ua-parser to identify the device type.
 * @returns {string} The type of device ('mobile', 'tablet', or 'desktop').
 */
export default function getDeviceType() {
  const { device } = UAParser(navigator.userAgent);

  switch (device.type) {
    case 'mobile':
    case 'wearable':
      return 'mobile';
    case 'tablet':
      return 'tablet';
    default:
      return 'desktop';
  }
}
